/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { OptionTypeBase } from "./common";

export interface IPatientPortalRequest {
  id?: string;
  name?: string;
  enabled?: boolean;
  eventTypes?: string[];
  notificationChannels?: string[];
  notificationPreference?: string;
  authenticationChannels?: string[];
  authenticationPreference?: string;
  sessionDuration?: number;
  studyDelay?: number;
  reportDelay?: number;
  autoEnroll?: boolean;
  studiesWithin?: number;
  reportsWithin?: number;
}

export interface IPatientPortal {
  id?: string;
  name?: string;
  enabled?: boolean;
  eventTypes?: OptionTypeBase[];
  notificationChannels?: Array<string>;
  notificationPreference?: string | null;
  authenticationChannels?: Array<string>;
  authenticationPreference?: string | null;
  sessionDuration?: number;
  sessionDurationUnit?: OptionTypeBase | null;
  studyDelay?: number;
  studyDelayUnit?: OptionTypeBase | null;
  reportDelay?: number;
  reportDelayUnit?: OptionTypeBase | null;
  autoEnroll?: boolean;
  logoUrl?: string;
  bannerUrl?: string | null;
  showStudiesNoLimit?: boolean;
  studiesWithin?: number;
  studiesWithinUnit?: OptionTypeBase | null;
  showReportsNoLimit?: boolean;
  reportsWithin?: number;
  reportsWithinUnit?: OptionTypeBase | null;
}

export interface IStudyOrderResponse {
  id?: string;
  studyId?: string;
  orderId?: string;
  description?: string;
  date?: string;
  referrer?: string;
  reportedBy?: string;
  createdAt?: string;
  issuedAt?: string;
  hasReport?: boolean;
  imagesAvailableAt?: Date | string;
  reportAvailableAt?: Date | string;
  imagesAvailableUntil?: Date | string;
  reportAvailableUntil?: Date | string;
  hasImages?: boolean;
  imageCount?: number;
}

export interface IStudyOrderDetailsResponse {
  id?: string;
  description?: string;
  date?: string;
  verifiedAt?: string;
  accessionNumber?: string;
  modalities?: string[];
  referrer?: string;
  reportedBy?: string;
  hasReport?: boolean;
  imagesAvailableAt?: number;
  reportAvailableAt?: number;
  imagesAvailableUntil?: number;
  reportAvailableUntil?: number;
  hasImages?: boolean;
  imageCount?: number;
  anySeriesHidden?: boolean;
}

export const defaultStudyOrderDetailsResponse: Readonly<IStudyOrderDetailsResponse> =
  {
    id: "",
    description: "",
    date: "",
    verifiedAt: "",
    accessionNumber: "",
    modalities: [],
    referrer: "",
    reportedBy: "",
    hasReport: false,
    hasImages: false,
    imageCount: 0,
  };

export const defaultPatientPortal: Readonly<IPatientPortal> = {
  id: "",
  enabled: false,
  eventTypes: [],
  notificationChannels: [],
  notificationPreference: null,
  authenticationChannels: [],
  authenticationPreference: null,
  sessionDuration: 60,
  sessionDurationUnit: null,
  studyDelay: 0,
  studyDelayUnit: null,
  reportDelay: 0,
  reportDelayUnit: null,
  autoEnroll: true,
  logoUrl: "",
  bannerUrl: "",
  showStudiesNoLimit: true,
  studiesWithin: 0,
  studiesWithinUnit: null,
  showReportsNoLimit: true,
  reportsWithin: 0,
  reportsWithinUnit: null,
};
